import { Component, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { GlobalService } from '../../services/global.service';
import { PreaprovalServices } from '../../services/preaprovals.services';
import { AdminServices, McaApplicationService, AuthenticationService } from '@app/services';

@Component({
  selector: 'app-upload-preapprovals',
  templateUrl: './upload-preapprovals.component.html',
  styleUrls: ['./upload-preapprovals.component.scss'],
  standalone: false
})
export class UploadPreapprovalsComponent implements OnInit {

  permissionAccess: boolean = false;
  fileToUpload: any;
  partnerSelected: any = null;
  partners: any[] = [];
  headers: Array<any> = null;
  headersToVerify: Array<string> = [
    'amount_preapproved',
    'payback',
    'term_maximum',
    'rate_interest_regular',
    'retention_percentage_sale',
    'amount_payment_minimum',
    'monthly_cap',
    'merchant_external_user_id',
    'funded_by',
    'type_preapprovals_id',
    'cat',
    'status'
  ];
  headerNotMatch: Array<string> = [];
  currentUser: any = null;
  enableCampaign: boolean = false;
  isCustomCampaign: boolean = false;
  customCampaignId: string = '';

  // Mes/año para el campaign_id (YYYYMM).
  campaignMonth: number = new Date().getMonth() + 1;
  campaignYear: number = new Date().getFullYear();
  months: Array<{ value: number; label: string }> = [
    { value: 1, label: 'Enero' }, { value: 2, label: 'Febrero' }, { value: 3, label: 'Marzo' },
    { value: 4, label: 'Abril' }, { value: 5, label: 'Mayo' }, { value: 6, label: 'Junio' },
    { value: 7, label: 'Julio' }, { value: 8, label: 'Agosto' }, { value: 9, label: 'Septiembre' },
    { value: 10, label: 'Octubre' }, { value: 11, label: 'Noviembre' }, { value: 12, label: 'Diciembre' }
  ];
  years: number[] = [];

  constructor(
    public globalServices: GlobalService,
    public preapprovalService: PreaprovalServices,
    private _snackBar: MatSnackBar,
    private mcaServices: McaApplicationService,
    private adminService: AdminServices,
    private authService: AuthenticationService
  ) {
    this.currentUser = this.authService.currentUserValue;
  }

  ngOnInit(): void {
    this.verifyPermissionAccess();
    this.getPartners();
    const currentYear = new Date().getFullYear();
    this.years = [currentYear, currentYear + 1];
  }

  get isMcaPartner(): boolean {
    return Number(this.partnerSelected?.product_type) === 1;
  }

  async getFileBufer(event) {
    if (event.target.files.length === 0) {
      this.showMeesage('No se pudo leer el archivo');
      return;
    }

    this.fileToUpload = event.target.files[0];

    if (this.fileToUpload.type !== 'text/csv') {
      this.showMeesage('El archivo seleccionado no es CSV');
      return;
    }

    this.readFileAsText(event);
    this.fileToUpload = await this.readFile(this.fileToUpload);

    if (this.partnerSelected.name.toLowerCase() === 'netpay' && this.partnerSelected.product_type === 6) {
      this.headersToVerify = [
        'amount_preapproved', 'payback', 'rate_interest_regular', 'retention_percentage_sale',
        'past_due_interest_rate', 'term_days', 'term_maximum', 'amount_payment_minimum',
        'cat', 'merchant_external_user_id', 'funded_by', 'type_preapprovals_id'
      ];
    }

    for (const header of this.headersToVerify) {
      if (!this.headers.includes(header)) {
        this.headerNotMatch.push(header);
      }
    }

    if (this.headerNotMatch.length > 0) {
      alert(`Error, No se encontraron las siguientes columnas: ${JSON.stringify(this.headerNotMatch)}`);
    }
  }

  readFile(file): Promise<string> {
    return new Promise((resolve) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = (e) => resolve((e.target!.result as string).split(',')[1]);
    });
  }

  readFileAsText(event: any): void {
    const file = event.target.files[0];
    const reader = new FileReader();
    reader.readAsText(file);
    reader.onload = () => {
      const csvRecordsArray = (reader.result as string).split(/\r\n|\n/);
      this.headers = (csvRecordsArray[0] as string).split(',');
    };
  }

  onSentDataPerson(): void {
    if (!this.fileToUpload || !this.partnerSelected) {
      this.showMeesage('Es necesario que seleccione el archivo CSV y un Partner');
      return;
    }

    let isCustom = this.isCustomCampaign || !this.isMcaPartner;
    if (this.enableCampaign && isCustom && !this.customCampaignId?.trim()) {
      this.showMeesage('Es necesario ingresar el identificador de campaña custom');
      return;
    }

    let useAutoCampaign = this.enableCampaign && !this.isCustomCampaign && this.isMcaPartner;
    let useCustomCampaign = this.enableCampaign && isCustom;

    // Solo se manda el mes cuando aplica campaña MCA automática
    let campaignMonth = useAutoCampaign
      ? `${this.campaignYear}${String(this.campaignMonth).padStart(2, '0')}`
      : null;

    let data = {
      fileCsv: this.fileToUpload,
      partner: this.partnerSelected.code,
      user_id: this.currentUser.userId,
      generateCampaign: useAutoCampaign,
      campaignMonth,
      customCampaignId: useCustomCampaign ? this.customCampaignId.trim() : null
    };

    const title = 'Confirmar envío';
    const message = `¿Está seguro de generar preapprovals para el Partner: ${this.partnerSelected.view_name}?`;

    this.globalServices.prepareModal({ title, message }).subscribe((result) => {
      if (result !== 'ok') return;

      this.preapprovalService.uploadPreapprovals(data).subscribe((res) => {
        if (!res.error) {
          this.globalServices.prepareAlert({ title: 'Éxito', message: res.message, label: 'success' }).subscribe();
        } else {
          this.globalServices.prepareAlert({ title: 'Error', message: res.message, label: 'error' }).subscribe();
        }
      });

      setTimeout(() => window.location.reload(), 5500);
    });
  }

  getPartners(): void {
    this.adminService.getAllProviders().subscribe((res) => {
      const viewNameMap = {
        1: 'mca',
        6: 'liquid advance'
      };

      this.partners = res.data
        .filter((p: any) => ![2, 3, 4, 5, 7].includes(p.product_type))
        .map((p: any) => ({ ...p, view_name: `${p.name} - ${(viewNameMap as any)[p.product_type] ?? p.product_type}` }));
    });
  }

  setPartner(partner: any): void {
    this.partnerSelected = partner;
  }

  showMeesage(message: string): void {
    this._snackBar.open(message, '', {
      duration: 4000,
      verticalPosition: 'top',
      horizontalPosition: 'center'
    });
  }

  verifyPermissionAccess(): void {
    this.permissionAccess = this.authService.modulesPermission.includes('upload_prepprovals');
  }

}
